<template>
  <ScheduleControlContent>
    <h3>Horarios</h3>
    <hr/>
    <b-modal v-model="pickerSelectorOpen" :width="400" scroll="keep">
      <div class="picker-content">
        <b-clockpicker
            v-model="tempTime"
            inline
            type="is-info"
            placeholder="Seleccione una hora"
            name="tempTime"
        >
          <b-button
              label="Hora actual"
              type="is-info"
              hour-format="24"
              icon-left="clock"
              @click="tempTime = new Date()"
          />
          <b-button
              label="Aceptar"
              type="is-info"
              icon-left="check"
              class="ml-3"
              outlined
              @click="accept()"
          />
        </b-clockpicker>
      </div>
    </b-modal>
    <div class="pt-2 pl-2 pr-2 pb-2" v-if="rangeError">
      <vs-alert title="Error" :active="true" color="danger">
        {{ rangeError }}
      </vs-alert>
    </div>

    <vs-button
        color="primary"
        icon="add"
        @click="addNewSchedule()"
        class="mb-3"
        v-if="!newSchedule">
      Adicionar nuevo horario
    </vs-button>
    <vs-card style="border-radius: 10px;">
      <div class="widget" v-if="newSchedule">

        <div class="columns">
          <div class="column">
            <b-field label="Día inicial">
              <b-select
                  placeholder="Seleccione un día"
                  expanded
                  v-model="initDay"
                  :value="initDay"
                  v-validate="'required'"
                  name="initDay"
              >
                <option
                    v-for="option in weekDays"
                    :value="option.id"
                    :key="option.id"
                    :id="option.id"
                >
                  {{ option.label }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <div class="hour-group">
              <b-field label="Hora inicio">
                <b-input
                    :placeholder="getDate(new Date())"
                    type="text"
                    v-model="toString"
                    v-validate="'required'"
                    name="toString"
                    :disabled="true"
                ></b-input>
                <b-button type="is-info" title="Agregar" @click="selectDate('to')"
                ><i class="mdi mdi-clock-outline"></i
                ></b-button>
              </b-field>
            </div>
          </div>
          <div class="column">
            <b-field label="Día final">
              <b-select
                  placeholder="Seleccione un día"
                  expanded
                  v-model="finalDay"
                  :value="finalDay"
                  v-validate="'required'"
                  name="finalDay"
                  :disabled="finalDayDisabled"
              >
                <option
                    v-for="option in weekDays"
                    :value="option.id"
                    :key="option.id"
                    :id="option.id"
                >
                  {{ option.label }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <div class="hour-group">
              <b-field label="Hora fin">
                <b-input
                    :placeholder="getDate(new Date())"
                    type="text"
                    v-model="fromString"
                    v-validate="'required'"
                    name="fromString"
                    :disabled="true"
                ></b-input>
                <b-button
                    type="is-info"
                    title="Agregar"
                    @click="selectDate('from')"
                ><i class="mdi mdi-clock-outline"></i
                ></b-button>
              </b-field>
            </div>
          </div>
          <div class="column mt-button2">
            <b-button
                type="is-info"
                title="Agregar"
                :disabled="!validLine()"
                @click="saveNewSchedule()"
            ><i class="mdi mdi-check"></i
            ></b-button>
            <b-button
                type="is-danger"
                title="Eliminar"
                @click="removeNewSchedule()"
            ><i class="mdi mdi-close"></i
            ></b-button>
          </div>
        </div>

      </div>
    </vs-card>

    <!--           --->

    <div>
      <vs-card style="border-radius: 10px;">
        <vs-table
            :data="schedules"
            v-model="selectedSchedule">
          <template slot="header">
            <h3>
              Rangos de horarios
            </h3>
          </template>
          <template slot="thead">
            <vs-th sort-key="day">Día inicial</vs-th>
            <vs-th sort-key="initialHour">Hora inicial</vs-th>
            <vs-th sort-key="finalDay">Día final</vs-th>
            <vs-th sort-key="finalHour">Hora final</vs-th>
            <vs-th sort-key="option">Opciones</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].day">
                {{ getDayName(data[indextr].day) }}
              </vs-td>
              <vs-td :data="data[indextr].initialHour">
                {{ getDate(data[indextr].initialHour) }}
              </vs-td>
              <vs-td :data="data[indextr].finalDay">
                {{ getDayName(data[indextr].finalDay) }}
              </vs-td>
              <vs-td :data="data[indextr].finalHour">
                {{ getDate(data[indextr].finalHour) }}
              </vs-td>
              <vs-td :data="data[indextr].day">
                <div class="d-flex align-items-center">
                  <vs-button
                      color="primary"
                      type="filled"
                      icon="edit"
                      class="btn-option"
                      title="Editar"
                  ></vs-button>
                  <vs-button
                      color="danger"
                      type="filled"
                      icon="delete"
                      title="Eliminar"
                      class="btn-option ml-1"
                      @click="remove(data[indextr])"
                  ></vs-button>
                </div>
              </vs-td>

            </vs-tr>
          </template>

        </vs-table>
      </vs-card>
    </div>
  </ScheduleControlContent>
</template>

<script>
import {ScheduleControlContent} from "./styles";
import {v1} from "uuid";
import DateUtils, {DEFAULT_TIME_ZONE} from "../../../global/DateUtils";
import {ROUTES} from "@/global/api_routes";
import {confirmation, swal} from "@/global/utils";
import {
  INCOHERENT_MESSAGE,
  OVERLAP_MESSAGE,
  isCoherentRange,
  overlapsAny,
} from "../scheduleOverlap";

export default {
  name: "ScheduleControl",
  components: {ScheduleControlContent},
  props: {
    schedules: Array,
    default: [],
  },
  data: () => ({
    newSchedule: null,
    rangeError: null,
    deleting: false,
    actualCode: null,
    actualSelectionIndex: null,
    pickerSelectorOpen: false,
    duration: "02:00",
    timezone: DEFAULT_TIME_ZONE,
    tempTime: new Date(),
    selectedSchedule: null,
    lastFrom: null,
    lastIndex: null,
    to: null,
    from: null,
    toString: null,
    fromString: null,
    initDay: null,
    finalDay: null,
    actualControlSelection: null,
    finalDayDisabled: false,
    loadingSelection: false,
    weekDays: [
      {label: "Lunes", id: 1},
      {label: "Martes", id: 2},
      {label: "Miércoles", id: 3},
      {label: "Jueves", id: 4},
      {label: "Viernes", id: 5},
      {label: "Sábado", id: 6},
      {label: "Domingo", id: 7},
      {label: "Festivo", id: 8, special: true},
      {label: "Especial", id: 9, special: true},
    ],

  }),
  watch: {
    selectedSchedule(selectedSchedule) {
      // Se marca la carga en curso: al asignar initDay se dispara su watcher
      // (checkSpecialDays), que para un día no especial hace finalDay = null y
      // borraba el día final recién asignado. Con este flag el watcher no toca
      // finalDay mientras se está cargando el rango a editar.
      this.loadingSelection = true;
      this.newSchedule = true;
      this.actualCode = selectedSchedule.index;
      this.initDay = selectedSchedule.day;
      this.finalDay = selectedSchedule.finalDay;
      this.finalDayDisabled = this.isDaySpecial(selectedSchedule.day);
      this.to = selectedSchedule.initialHour;
      this.from = selectedSchedule.finalHour;
      this.toString = this.getDate(selectedSchedule.initialHour);
      this.fromString = this.getDate(selectedSchedule.finalHour);
      this.$nextTick(() => {
        this.loadingSelection = false;
      });
    },
    initDay(value) {
      this.checkSpecialDays("initDay", value);
    },
    finalDay(value) {
      this.checkSpecialDays("finalDay", value);
    },
  },
  mounted() {
  },
  methods: {
    checkSpecialDays(field, value) {
      // Durante la carga de un rango en edición no se debe reiniciar finalDay:
      // ese valor ya viene del registro seleccionado.
      if (this.loadingSelection) {
        return;
      }
      if (field === "initDay" && this.isDaySpecial(value)) {
        this.finalDay = value;
        this.finalDayDisabled = true;
      } else if (field === "initDay") {
        this.finalDay = null;
        this.finalDayDisabled = false;
      }
    },
    isDaySpecial(dayId) {
      const day = this.weekDays.find((item) => item.id == dayId);
      if (!day) {
        return false;
      }
      return day.special;
    },
    updateList(list) {
      this.$emit("updateList", list);
    },
    remove(row) {
      confirmation(this, "¿Desea elminar el registro?").then((result) => {
        if (!result) {
          return;
        }
        // Un horario debe conservar al menos un rango.
        const activeCount = this.schedules.filter((item) => !item.deleted).length;
        if (activeCount <= 1) {
          this.rangeError = null;
          swal(
              this,
              "No se puede eliminar el único rango del horario. " +
              "Un horario debe tener al menos un rango."
          ).error();
          return;
        }
        // Rango que aún no existe en BD (sin code): solo se quita en memoria y
        // se consolidará al guardar/eliminar el horario.
        if (!row.code) {
          this.removeLocal(row);
          return;
        }
        // Rango ya persistido: se elimina de inmediato en el backend, sin
        // esperar al botón "Guardar" del formulario principal.
        if (this.deleting) {
          return;
        }
        this.deleting = true;
        this.$http
            .delete(ROUTES.DASHBOARD.SCHEDULES.DELETE_SCHEDULE_DAY, {
              data: {scheduleDayId: row.code},
            })
            .then(({data}) => {
              this.deleting = false;
              if (data.code > 0) {
                this.removeLocal(row);
                return;
              }
              swal(this, data.message).error();
            })
            .catch(() => {
              this.deleting = false;
              swal(this, "Error al eliminar el rango del horario").error();
            });
      });
    },
    removeLocal(row) {
      const list = this.orderSchedules(
          this.schedules.map((item) => {
            if (item === row || (row.code && item.code === row.code)) {
              item.deleted = true;
            }
            return item;
          })
      );
      this.rangeError = null;
      this.updateList(list);
    },
    getDayName(day) {
      if (!day) {
        return "---";
      }
      return this.weekDays.find((d) => d.id == day).label;
    },
    validLine() {
      return this.initDay && this.finalDay && this.to && this.from;
    },
    getSchedules() {
      return Object.assign([], this.schedules);
    },
    addNewSchedule() {
      this.to = null;
      this.from = null;
      this.fromString = null;
      this.toString = null;
      this.initDay = null;
      this.finalDay = null;
      this.finalDayDisabled = false;
      this.actualCode = null;
      this.rangeError = null;
      this.newSchedule = true;
    },
    removeNewSchedule() {
      this.newSchedule = null;
      this.to = null;
      this.from = null;
      this.toString = null;
      this.fromString = null;
      this.rangeError = null;
    },
    saveNewSchedule() {
      const newSchedule = {
        day: this.initDay,
        initialHour: this.to,
        finalDay: this.finalDay,
        finalHour: this.from,
        code: this.actualCode,
        index: this.actualCode ? this.actualCode : this.schedules.length,
      };
      if (!isCoherentRange(newSchedule)) {
        this.rangeError = INCOHERENT_MESSAGE;
        swal(this, INCOHERENT_MESSAGE).error();
        return;
      }
      const others = this.schedules.filter(
        (item) => !item.deleted && item.index != newSchedule.index
      );
      if (overlapsAny(newSchedule, others)) {
        this.rangeError = OVERLAP_MESSAGE;
        swal(this, OVERLAP_MESSAGE).error();
        return;
      }
      this.rangeError = null;
      this.validateNewSchedule(newSchedule);
    },
    validateHour(listHours, hour) {
      const {timezone} = this;
      const actualTo = DateUtils.toHourString({
        date: hour.initialHour,
        timezone,
      });
      const actualFrom = DateUtils.toHourString({
        date: hour.finalHour,
        timezone,
      });
      listHours.forEach((h, i) => {
        if (!h.removed) {
          const tempTo = DateUtils.toHourString({
            date: h.initialHour,
            timezone,
          });
          const tempFrom = DateUtils.toHourString({
            date: h.finalHour,
            timezone,
          });

          const v = DateUtils.timeBetween({
            time: actualTo,
            beforeTime: tempTo,
            afterTime: tempFrom,
            timezone,
          });

          const v2 = DateUtils.timeBetween({
            time: actualFrom,
            beforeTime: tempTo,
            afterTime: tempFrom,
            timezone,
          });

          if (v || v2) {
            this.addError(
                hour,
                "Estás superponiendo horarios, por favor verifica tus rangos."
            );
          }
        }
      });
    },
    validateNewSchedule(newSchedule) {
      let schedulesNew = [...this.schedules];
      const valid = true;
      const index = schedulesNew.findIndex(
          (item) => item.index == newSchedule.index
      );
      if (index >= 0) {
        schedulesNew[index] = newSchedule;
      } else if (valid) {
        schedulesNew.push(newSchedule);
      }
      schedulesNew = this.orderSchedules(schedulesNew);
      this.newSchedule = null;
      this.updateList(schedulesNew);
    },
    validateSchedules(schedules) {
      const {timezone} = this;
      for (const key in schedules) {
        if (schedules.hasOwnProperty(key)) {
          const schedule = schedules[key];
          if (!schedule) {
            continue;
          }
          const list = schedule.list.filter((group) => !group.removed);
          list.forEach((hour, index) => {
            if (
                DateUtils.isBefore({
                  before: hour.from,
                  date: hour.to,
                  by: "s",
                  timezone,
                })
            ) {
              this.addError(hour, "Hora inicial es mayor que hora final.");
            } else {
              hour.errors = null;
            }
            if (index > 0) {
              this.validateHour(list, hour, index);
            }
          });
        }
      }
      return schedules;
    },
    removeScheduleItem(group, i) {
      let {schedules} = this;
      const rangeSchedule = schedules[group.index];
      if (!rangeSchedule) {
        return;
      }
      const hourIndex = rangeSchedule.list.findIndex(
          (hour) =>
              (hour.tempId && hour.tempId == group.tempId) ||
              (hour.id && hour.id == group.id)
      );
      schedules[group.index].list[hourIndex].removed = true;
      schedules = this.orderSchedules(schedules);
      schedules = this.validateSchedules(schedules);
      this.$emit("updateScheduleList", schedules);
      this.$forceUpdate();
    },
    getErrors() {
      const {schedules} = this;
      let errors = [];
      schedules.forEach((schedule) => {
        if (Array.isArray(schedule.errors) && schedule.errors.length > 0) {
          errors.push(schedule.errors.join(","));
        }
      });
      return errors;
    },
    selectDate(selection) {
      this.actualControlSelection = selection;
      this.pickerSelectorOpen = true;
    },
    getDate(time) {
      if (!time) {
        return null;
      }
      const timezone = this.timezone;
      return DateUtils.toHour12MinimalString({date: time, timezone});
    },
    addError(schedule, error) {
      if (!schedule.errors) {
        schedule.errors = [];
      }
      const v = schedule.errors.find((err) => err === error);
      !v && schedule.errors.push(error);
    },
    parseDuration(duration) {
      return parseInt(
          DateUtils.toHourString({
            date: duration,
            timezone: this.timezone,
          }).replace(/\:/g, "")
      );
    },
    orderSchedules(schedules) {
      return schedules.sort((a, b) => {
        const aDay = a.day;
        const bDay = b.day;
        const aTo = this.parseDuration(a.initialHour);
        const aFrom = this.parseDuration(a.finalHour);
        const bTo = this.parseDuration(b.initialHour);
        const bFrom = this.parseDuration(b.finalHour);
        return aTo - bTo && aFrom - bFrom && aDay - bDay;
      });
    },
    addSchedule(index) {
      let {schedules, duration, timezone} = this;
      const minutes = DateUtils.getTime({time: duration});

      if (!schedules[index]) {
        schedules[index] = {index, list: []};
      }
      let toInit = 0;
      let fromInit = 0;
      const list = schedules[index].list.filter((group) => !group.removed);

      if (list.length > 0) {
        const lastSchedule = list[list.length - 1];
        toInit = DateUtils.addMinutes({
          date: lastSchedule.from,
          amount: 1,
          timezone,
        });
      } else {
        toInit = DateUtils.startDate({date: new Date(), timezone});
      }
      fromInit = DateUtils.addMinutes({
        date: toInit,
        amount: minutes,
        timezone,
      });

      schedules[index].list.push({
        to: toInit,
        from: fromInit,
        added: true,
        index,
        tempId: v1(),
      });
      schedules = this.orderSchedules(schedules);
      schedules = this.validateSchedules(schedules);
      this.$emit("updateScheduleList", schedules);
      this.$forceUpdate();
    },
    async accept() {
      const {tempTime, actualControlSelection} = this;
      this[actualControlSelection] = tempTime;
      this[`${actualControlSelection}String`] = this.getDate(tempTime);
      this.pickerSelectorOpen = false;
    },
    openSelector(index) {
      this.actualSelectionIndex = index;
      this.pickerSelectorOpen = true;
    },
  },
};
</script>
